// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.settingBox[data-v-f85a7768]{padding:50px; border:1px solid #b8b8b8;}\n.LedPatternClass + input[data-v-f85a7768]{\n  display: contents !important;\n}\n", ""]);
// Exports
module.exports = exports;
